import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-no-house-user',
  templateUrl: './no-house-user.component.html',
  styleUrls: ['./no-house-user.component.scss']
})
export class NoHouseUserComponent implements OnInit {
  customerServiceNumber: string;
  
  constructor(private generalService: GeneralService) { }

  ngOnInit() {
    this.customerServiceNumber = this.generalService.getCustomerSupportNumber();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/no-house-user/no-house-user.component.ts